import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import { getPlannedPost } from '../../../../../redux/slices/lomavisCreator/utils';
import { generatePath } from 'react-router-dom';
import toast from 'react-hot-toast';
import { ALL, PLATFORM_LIST } from '../../../../../config/constants';

import { Button, OverlayTrigger } from 'react-bootstrap';
import { Tooltip } from 'bootstrap';
import { tolgee } from '../../../../../locales/toglee';
import { getLanguage } from '../../../../../locales/i18n';
import { useDispatch, useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../../pages/lomavisCreator';
import { useTranslate } from '@tolgee/react';
import { mondayStartLocales } from '../../../config/constants';
import { isPastDate } from '../../../utils/helpers';
import {
  addPublicationDate,
  addPublicationDateTime,
  addPublicationTime,
  bestTimeToPostValue
} from '../../../../../redux/slices/lomavisCreator/lomavisCreator';
import moment from 'moment';
import '../schedule.css';
import { platform } from 'os';
import { getDateTimeFormated } from '../../../../utils/dates/utils';

interface Props {
  locationslug: string;
  setLoadingData: React.Dispatch<React.SetStateAction<boolean>>;
  filterArray: string[];
}

const Calendar: React.FC<Props> = ({
  locationslug,
  setLoadingData,
  filterArray
}) => {
  let tooltipInstance = null;
  let currentTooltipElement = null;
  let clickLock = false;

  const dispatch = useDispatch();

  const currentDate = new Date();
  const targetRef = useRef(null);
  const [showToolTip, setShowToolTip] = useState(false);
  const [infoFetch, setInfoFetch] = useState({ start: null, end: null });
  const [apiData, setApiData] = useState([]);
  const [draftPostData, setDraftPostData] = useState([]);
  const [filteredApiData, setFilteredApiData] = useState([]);

  const timeZone = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.timeZone
  );
  const isMultiPost = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.is_multipost
  );
  const platformEnabled = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.platformEnabled
  );

  const { useSeparateMediaFiles, useSeparateTextFields } = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );

  // const isMultiPost = () => {
  //   return true;
  // };
  const lomavisScheduleCalendarLoadingSpinnerRef = useRef(null);
  let spinner = lomavisScheduleCalendarLoadingSpinnerRef.current;

  const CURRENT_POST_STATUS_DRAFT = 2;
  const CURRENT_POST_STATUS_APPROVAL = 3;
  const CURRENT_POST_STATUS_READY = 4;

  const lomavisCreatorContainerRef = useRef(null);

  const fetchData = async () => {
    const configData = {
      apiUrl: generatePath('/api/v1/posts/planned')
    };
    const apiUrlIsDefined = configData.apiUrl;
    if (!apiUrlIsDefined) return;

    // schedulingCalendarClearAllEvents()
    const locationSlug = locationslug;
    let url = null;
    if (isMultiPost) {
      url = `${configData.apiUrl}?start=${infoFetch.start}&end=${infoFetch.end}&only_multipost=1`;
    } else {
      url = `${configData.apiUrl}?start=${infoFetch.start}&end=${infoFetch.end}&location__slug=${locationSlug}`;
    }
    let multipost_filter = '';
    if (isMultiPost) {
      multipost_filter = '&only_multipost=1';
    }
    let recurringUrl = `${configData.apiUrl}?start=${infoFetch.start}&end=${infoFetch.end}${multipost_filter}&location__slug=${locationSlug}&is_recurring_post=True`;
    // open also next url if available -> fetch all objects with pagination
    let apiData = [];
    while (url !== null) {
      try {
        setLoadingData(true);
        const response = await fetch(url);
        let data = await response.json();

        url = data.next;

        apiData = [...apiData, ...data.results];
      } catch (error) {
        console.error(error);
        url = null;
        toast.error(`Loading calendar failed. Please reload the page`, {
          duration: 4000,
          position: 'top-right'
        });

        // Sentry.captureException(error);
      }
    }
    try {
      setLoadingData(true);
      const response = await fetch(recurringUrl);
      let data = await response.json();
      try {
        apiData = [...apiData, ...data.results];
      } catch (error) {}
    } catch (error) {
      console.error(error);
      toast.error('Loading calendar failed. Please reload the page.');
      // Sentry.captureException(error);
    }

    setApiData([...apiData]);
    setLoadingData(false);
  };

  useEffect(() => {
    if (infoFetch.start && infoFetch.end) {
      fetchData();
    }
  }, [infoFetch]);

  const events = async (fetchInfo, successCallback, failureCallback) => {
    if (
      infoFetch.start !== fetchInfo.startStr &&
      infoFetch.end !== fetchInfo.endStr
    ) {
      setInfoFetch({ start: fetchInfo.startStr, end: fetchInfo.endStr });
    }

    let schedulingCalendarRenderedEvents = [];

    for (let i = 0; i < filteredApiData.length; i++) {
      let multiPostObject = filteredApiData[i];
      // setup separate event objects for posts with a different publication time
      // todo: these should be constants
      const post_fields = PLATFORM_LIST.map((x) => x + '_post');
      let postsGroupedByPublicationDate = {};
      for (let key of post_fields) {
        const post = multiPostObject[key];
        const postIsAvailable = post !== null;
        if (!postIsAvailable) continue;

        const plannedPublicationDateTime =
          post?.upload_to_platform_timestamp ||
          post?.planned_publication_datetime ||
          multiPostObject.created;

        // console.log(
        //   "planned publication datetime",
        //   plannedPublicationDateTime,
        //   post?.upload_to_platform_status
        // );

        // we group by publication date and also publication status. Publication status should always be
        // the same execept when posts has been published. Then it can be successful published or
        // error
        let groupKey = `${plannedPublicationDateTime}_${post?.upload_to_platform_status}`;
        const groupExists =
          Object.keys(postsGroupedByPublicationDate).indexOf(groupKey) > -1;
        if (!groupExists) postsGroupedByPublicationDate[groupKey] = {};
        postsGroupedByPublicationDate[groupKey][key] = post;
      }

      const eventCopy = JSON.parse(JSON.stringify(multiPostObject));

      for (let key of post_fields) {
        eventCopy[key] = null;
      }

      for (let plannedPublicationDateTime of Object.keys(
        postsGroupedByPublicationDate
      )) {
        let newEvent = JSON.parse(JSON.stringify(eventCopy));
        newEvent.start = plannedPublicationDateTime.split('_')[0];
        let postsForPlatform =
          postsGroupedByPublicationDate[plannedPublicationDateTime];
        for (let key of Object.keys(postsForPlatform)) {
          newEvent[key] = postsForPlatform[key];
          if (newEvent.has_been_published) {
            newEvent.post_status = CURRENT_POST_STATUS_READY;
            // posts that have been published can have errors. Here we adjust the status to
            const errorDuringPublishing =
              postsForPlatform[key].upload_to_platform_status === 4;
            if (errorDuringPublishing) {
              newEvent.has_publication_error = true;
              newEvent.uuid = postsForPlatform[key].uuid;
            }
          }
        }
        // we don't want that fullcalendar automatically redirects when a user clicks on an entry.
        // Therefore, we do not provide url with the event, which would be used by fullcalendar to
        // redirect the user. We will handle this ourself with an ondblclick event handler.
        newEvent._url = newEvent.url;
        delete newEvent.url;
        // schedulingCalendarInstance.addEvent(newEvent)
        //if (schedulingCalendarInstanceAlreadyAdded.indexOf(newEvent.uuid) === -1) {
        //    schedulingCalendarInstanceAlreadyAdded.push(newEvent.uuid)
        //    schedulingCalendarRenderedEvents.push(newEvent)
        //}

        schedulingCalendarRenderedEvents.push(newEvent);

        //if (self.isEventAlreadyRendered(self, newEvent)) {
        //    schedulingCalendarInstance.addEvent(newEvent)
        //}
      }
    }
    console.log('info', schedulingCalendarRenderedEvents);
    successCallback(schedulingCalendarRenderedEvents);
  };

  useEffect(() => {
    let draftPosts: any[] = [];
    let approvedPosts: any[] = [];
    let plannedPosts: any[] = [];
    let publishedPosts: any[] = [];
    if (filterArray.includes('Draft')) {
      const draftFromApi = apiData?.filter((item) => item.post_status === 2);
      draftPosts = [...draftPostData, ...draftFromApi];
    }
    if (filterArray.includes('Approval')) {
      approvedPosts = apiData?.filter((item) => item.post_status === 3);
    }
    if (filterArray.includes('Planned')) {
      plannedPosts = apiData?.filter(
        (item) =>
          item.post_status === 4 &&
          item.latest_upload_to_platform_timestamp === null
      );
    }
    if (filterArray.includes('Published')) {
      publishedPosts = apiData?.filter(
        (item) =>
          item.post_status === 4 &&
          item.latest_upload_to_platform_timestamp !== null
      );
    }

    setFilteredApiData([
      ...draftPosts,
      ...approvedPosts,
      ...plannedPosts,
      ...publishedPosts
    ]);
  }, [filterArray, apiData, draftPostData]);

  const allPostData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData
  );

  const addPostInfo = () => {
    let finishedArray = [];

    if (!useSeparateMediaFiles) {
      const postData = allPostData[ALL];

      if (postData?.tempPublicationData?.datetime) {
        const objectItem = {
          created_in_lomavis: true,
          is_recurring_post: false,
          post_status: 2,
          has_publication_error: false,
          latest_upload_to_platform_timestamp:
            postData?.tempPublicationData.datetime,
          planned_publication_datetime: postData?.tempPublicationData.datetime,
          created: postData?.tempPublicationData.datetime,
          show_new_label: false,
          show_edited_label: false,
          preview_image_url: postData?.media[0]?.preview_image,

          preview_html: postData.text?.ops
            ?.map((op) => op.insert || '')
            .join(''),
          is_video: postData?.media[0]?.media_type,
          is_multipost: false,
          content_type_is_story: false
        };

        PLATFORM_LIST.filter((platform) => platformEnabled[platform]).map(
          (platform) => {
            const postData = platformEnabled[platform] && allPostData[platform];
            return (objectItem[`${platform}_post`] = {
              api_url:
                '/api/v1/posts/single-posts/56562959-da5b-48d9-8642-76dfd1f838ab/',
              has_been_published: false,
              planned_publication_datetime:
                postData.tempPublicationData.datetime,
              upload_to_platform_status: 3,
              upload_to_platform_timestamp:
                postData?.tempPublicationData.datetime,
              uuid: '56562959-da5b-48d9-8642-76dfd1'
            });
          }
        );

        finishedArray.push(objectItem);
      }
    } else {
      PLATFORM_LIST.filter((platform) => platformEnabled[platform]).map(
        (platform) => {
          const postData = platformEnabled[platform] && allPostData[platform];

          if (postData?.tempPublicationData?.datetime) {
            const objectItem = {
              created_in_lomavis: true,
              is_recurring_post: false,
              post_status: 2,
              has_publication_error: false,
              latest_upload_to_platform_timestamp:
                postData?.tempPublicationData.datetime,
              planned_publication_datetime:
                postData?.tempPublicationData.datetime,
              created: postData?.tempPublicationData.datetime,
              show_new_label: false,
              show_edited_label: false,
              preview_image_url: postData?.media[0]?.preview_image,

              preview_html: postData.text?.ops
                ?.map((op) => op.insert || '')
                .join(''),
              is_video: postData?.media[0]?.media_type,
              is_multipost: false,
              content_type_is_story: false
            };
            objectItem[`${platform}_post`] = {
              api_url:
                '/api/v1/posts/single-posts/56562959-da5b-48d9-8642-76dfd1f838ab/',
              has_been_published: false,
              planned_publication_datetime:
                postData.tempPublicationData.datetime,
              upload_to_platform_status: 3,
              upload_to_platform_timestamp:
                postData?.tempPublicationData.datetime,
              uuid: '56562959-da5b-48d9-8642-76dfd1'
            };

            finishedArray.push(objectItem);

            console.log(platform);
          }
        }
      );
    }

    setDraftPostData([...finishedArray]);
  };

  useEffect(() => {
    addPostInfo();
    return;
  }, [allPostData]);

  function handleDateSelect(selectInfo) {
    console.log('date selected', selectInfo);
  }
  const { t } = useTranslate();

  return (
    <div
      style={{ overflowY: 'scroll', rowGap: '30px' }}
      className="w-100 d-flex flex-column h-100"
    >
      <FullCalendar
        height={'100%'}
        aspectRatio={1}
        ref={lomavisCreatorContainerRef}
        events={events}
        plugins={[dayGridPlugin, interactionPlugin]}
        timeZone={timeZone}
        initialView="dayGridMonth"
        slotEventOverlap={false}
        eventStartEditable={false}
        firstDay={mondayStartLocales.includes(getLanguage()) ? 1 : 0}
        locale={getLanguage()}
        buttonText={{
          today: t('lomavisCreator.calendar.today'),
          month: t('lomavisCreator.calendar.month'),
          week: t('lomavisCreator.calendar.week'),
          day: t('lomavisCreator.calendar.day')
        }}
        editable={true}
        selectable={true}
        selectMirror={true}
        nowIndicator={true}
        dayCellClassNames={(args) => {
          const today = moment().format('YYYY-MM-DD');
          return args.date.toISOString().split('T')[0] === today
            ? 'today-cell'
            : '';
        }}
        // This setting is important so that posts that are scheduled close to the end of the day do not
        // get displayed in the next day
        defaultTimedEventDuration={'00:00:00'}
        // eventClick={(info) => {
        //   let d = new Date(info.event.startStr);
        //   d.setHours(new Date().getHours());
        //   d.setMinutes(new Date().getMinutes());
        //   if (d > new Date()) {
        //     all_platform_publish_datetime_picker.dates.setValue(
        //       tempusDominus.DateTime.convert(d)
        //     );
        //   }
        // }}
        eventContent={function (arg, createElement) {
          const hasEnabledPlatform = PLATFORM_LIST.filter(
            (platform) => arg.event.extendedProps[`${platform}_post`]
          );

          if (hasEnabledPlatform?.length === 0) {
            return;
          }

          const newLabel = 'New';
          const editedLabel = 'Edited';
          let createdInLomavisHtml = '';
          if (!arg.event.extendedProps.created_in_lomavis) {
            createdInLomavisHtml =
              '<div class="mx-1" data-bs-toggle="tooltip" data-bs-placement="top"\n' +
              '       title="as">\n' +
              '    <i class="fa-duotone fa-down-to-bracket"></i>\n' +
              '  </div>';
          }

          let additional_icon_color = '';
          let facebook_icon = arg.event.extendedProps.facebook_post
            ? `<span class="d-flex"><i class=" fab fa-facebook  me-1" style="font-size: 20px; color: #3b5998;"></i><i class="${additional_icon_color} fa-duotone fa-home me-2 mt-2"></i></span>`
            : '';
          let facebook_group_icon = arg.event.extendedProps.facebook_group_post
            ? `<span class="d-flex"><i class=" fab fa-facebook me-1" style="font-size: 20px; color: #3b5998;"></i><i class="${additional_icon_color} fa-duotone fa-users fs-1x me-2 mt-2"></i></span>`
            : '';
          let instagram_icon = arg.event.extendedProps.instagram_post
            ? `<i class=" fab fa-instagram me-1" style="font-size: 20px; color: #e4405f;"></i>`
            : '';
          let google_icon = arg.event.extendedProps.google_post
            ? `<i class=" fab fa-google me-1" style="font-size: 20px; color: #4285f4;"></i>`
            : '';
          let twitter_icon = arg.event.extendedProps.twitter_post
            ? `<i class=" fab fa-twitter me-1" style="font-size: 20px; color: #1da1f2;"></i>`
            : '';
          let linkedin_icon =
            arg.event.extendedProps.linkedin_personal_account_post ||
            arg.event.extendedProps.linkedin_business_page_post
              ? '<i class="text-white fab fa-linkedin fs-1x me-1"></i>'
              : '';
          let linkedin_personal_account_icon = arg.event.extendedProps
            .linkedin_personal_account_post
            ? `<span class="d-flex"><i class=" fab fa-linkedin me-1" style="font-size: 20px; color: #0077b5;"></i><i class="${additional_icon_color} fa-duotone fa-user fs-1x me-2 mt-2"></i></span>`
            : '';
          let linkedin_business_page_icon = arg.event.extendedProps
            .linkedin_business_page_post
            ? `<span class="d-flex"><i class="fab fa-linkedin me-1" style="font-size: 20px; color: #0077b5;"></i><i class="${additional_icon_color} fa-duotone fa-home fs-1x me-2 mt-2"></i></span>`
            : '';
          let youtube_icon = arg.event.extendedProps.youtube_post
            ? `<i class=" fab fa-youtube fs-1x me-1" style="font-size: 20px; color: #ff0000;"></i>`
            : '';
          let tiktok_personal_account_icon = arg.event.extendedProps
            .tiktok_personal_account_post
            ? `<span class="d-flex"><i class=" fab fa-tiktok me-1" style="font-size: 20px; color: #000000;"></i><i class="${additional_icon_color} fa-duotone fa-user fs-1x me-2 mt-2"></i></span>`
            : '';
          let tiktok_business_page_icon = arg.event.extendedProps
            .tiktok_business_page_post
            ? `<span class="d-flex"><i class=" fab fa-tiktok me-1" style="font-size: 20px; color: #000000;"></i><i class="${additional_icon_color} fa-duotone fa-home fs-1x me-2 mt-2"></i></span>`
            : '';
          let recurring_icon = arg.event.extendedProps.is_recurring_post
            ? '<i class=" fa-duotone fa-sync fs-1x me-1"></i>'
            : '';
          let status = arg.event.extendedProps.post_status;
          let hasPublicationError =
            arg.event.extendedProps.has_publication_error;
          let hasBeenPublished =
            arg.event.extendedProps.latest_upload_to_platform_timestamp;
          let bgColor = 'bg-primary';
          let borderColor = 'border-primary';
          let locationNameHtml = '';
          let badgeHtml = '';
          if (arg.event.extendedProps.show_new_label) {
            badgeHtml = `<div class="w-100 d-flex justify-content-end px-1"><span class="badge bg-primary fw-bolder">${newLabel}</span></div>`;
          } else if (arg.event.extendedProps.show_edited_label) {
            badgeHtml = `<div class="w-100 d-flex justify-content-end px-1"><span class="badge bg-warning fw-bolder">${editedLabel}</span></div>`;
          }
          if (status === CURRENT_POST_STATUS_DRAFT) {
            bgColor = 'bg-warning ';
            borderColor = 'border-warning ';
          } else if (status === CURRENT_POST_STATUS_APPROVAL) {
            bgColor = 'bg-info ';
            borderColor = 'border-info ';
          } else if (
            status === CURRENT_POST_STATUS_READY &&
            !hasPublicationError &&
            hasBeenPublished
          ) {
            bgColor = 'bg-success';
            borderColor = 'border-success';
          } else if (
            status === CURRENT_POST_STATUS_READY &&
            hasPublicationError &&
            hasBeenPublished
          ) {
            bgColor = 'bg-gray-400 ';
            borderColor = 'border-secondary ';
          }
          bgColor = 'bg-white';
          let hasErrorHtml = '';
          if (hasPublicationError) {
            let errorLabel = 'Error';
            hasErrorHtml = `<div class="w-100 d-flex justify-content-center px-1 ${bgColor} rounded mb-1 fw-bolder"><span class="fw-bolder text-white">${errorLabel}</span></div>`;
          }
          let publication_time_start =
            arg.event._instance.range.start.toLocaleTimeString([], {
              timeStyle: 'short'
            });
          let imgTag = '';
          let previewTextCssClasses = 'col-12';
          let previewImageUrl = arg.event.extendedProps.preview_image_url;
          let isVideo = arg.event.extendedProps.is_video;
          if (previewImageUrl !== null) {
            previewTextCssClasses = 'col-12 col-md-8';
            if (!isVideo) {
              imgTag = `<div class="col-12 col-md-4 px-0 h-50px"><img class="mw-100 mh-100" src="${previewImageUrl}"></div>`;
            } else {
              //imgTag = `<div class="col-12 col-md-4 px-0"><div class="d-flex justify-content-center align-items-center h-100"><div class="position-absolute"><i class="fa-duotone fa-play-circle fs-2x text-white"></i></div> <img class="mw-100 mh-100" src="${previewImageUrl}"></div></div>`
              imgTag = `<div class="col-12 col-md-4 px-0 d-flex align-items-center h-50px"><div class="d-flex justify-content-center align-items-center mh-100 h-100 position-absolute justify-content-center"><i class="fa-duotone fa-play-circle fs-2x text-white"></i></div> <img class="mh-100" data-video="true" src="${previewImageUrl}" onload="if (!$(this).data().video) return; if (this.width > this.height){$(this).parent().addClass('justify-content-center'); if ($(this).width() > $(this).parent().width()){}$(this).width($(this).parent().width());console.log($(this).parent().width(), $(this).width())}"></div>`;
            }
          }
          const openingLomavisCreatorMessage = 'Opening Lomavis Creator';
          let html =
            `<div class="d-flex flex-column w-100">` +
            badgeHtml +
            `<div class="d-flex flex-column w-100 border border bg-white ${borderColor} border-end-0 border-bottom-0 border-top-0 rounded px-1" style="border-width: 5px !important;">` +
            `<div class="d-flex align-items-center justify-co    ntent-between ${bgColor} text-white rounded-end mb-1 fw-bolder"><span>${createdInLomavisHtml}</span><span class="d-flex flex-row align-items-center me-2"><i class="fa-duotone fa-clock me-1 text-white fs-1x d-none d-md-block"></i> ${publication_time_start}</span></div>` +
            hasErrorHtml +
            '<div class="d-flex flex-column flex-md-row">' +
            imgTag +
            `<div class="${previewTextCssClasses} px-0 px-md-1 overflow-hidden nowrap text-dark fw-bolder d-md-none abcdef" style="text-overflow: ellipsis; white-space: nowrap;">` +
            arg.event._def.title +
            '</div>' +
            `<div class="${previewTextCssClasses} px-0 px-md-1 overflow-hidden nowrap text-dark fw-bolder d-none d-md-block" style="text-overflow: ellipsis; white-space: break-spaces; max-height: 55px;">` +
            arg.event._def.title +
            '</div>' +
            '</div>' +
            '<div class="d-flex flex-wrap mt-1">' +
            facebook_icon +
            instagram_icon +
            google_icon +
            twitter_icon +
            linkedin_icon +
            '</div>' +
            locationNameHtml +
            `<div class="w-100 text-end text-small"><div onclick="event.stopPropagation();toastr.success('${openingLomavisCreatorMessage}');location.href='${arg.event.extendedProps._url}'"><i class="fa-duotone fa-pencil fs-1x"></i></div></div>` +
            '</div>' +
            '</div>';
          let multiPostHtml = '';
          if (arg.event.extendedProps.is_multipost) {
            multiPostHtml = `<span class="me-1"><i class="fa-duotone fa-paste"></i></span><span class="me-1">${arg.event.extendedProps.multipost_copy_count}</span>`;
          }
          let storyHtml = '';
          if (arg.event.extendedProps.content_type_is_story) {
            multiPostHtml =
              '<span class="me-1"><i class="fa-duotone fa-circle-play"></i></span>';
          }
          if (arg.event.extendedProps.is_recurring_post) {
            if (status === CURRENT_POST_STATUS_READY) {
              bgColor = 'bg-white border-primary';
              borderColor = 'border-primary border';
            }
          }
          let seperatorHTML = '';
          if (
            multiPostHtml !== '' ||
            storyHtml !== '' ||
            createdInLomavisHtml !== ''
          ) {
            seperatorHTML = '<span class="me-1"> | </span>';
          }
          html = `<div class="d-flex flex-column w-100  border ${borderColor} ${bgColor} px-1 py-1  rounded"><div class="d-flex flex-wrap align-items-center">${recurring_icon} ${createdInLomavisHtml}${multiPostHtml}${storyHtml}${seperatorHTML}${facebook_icon} ${facebook_group_icon} ${instagram_icon} ${google_icon} ${twitter_icon} ${linkedin_personal_account_icon} ${linkedin_business_page_icon} ${youtube_icon} ${tiktok_personal_account_icon} ${tiktok_business_page_icon}</div></div>`;
          return { html: html };
        }}
        eventMouseEnter={(info) => {
          if (clickLock) return;
          if (currentTooltipElement === info.el) {
            return;
          }

          currentTooltipElement = info.el;

          let data = info.event._def.extendedProps;

          let imageSrc = data.preview_image_url || '';
          let postText = data.preview_html;
          let badgeMultiPost = '';
          let badge = '';
          let multipost_text = 'Multipost';
          let profile_groups_text = 'Profile groups';
          let multiimage_text = 'Multi image';
          let video_text = 'Video';
          let single_image_post_text = 'Post';
          let story_text = 'Story';
          let reel_text = 'Reel';
          if (data.content_type_is_multiimage_post) {
            badge = `<span class="badge badge-white">${multiimage_text}</span>`;
          }
          if (data.content_type_is_video) {
            badge = `<span class="badge badge-info">${video_text}</span>`;
          }
          if (data.content_type_is_single_image_post) {
            badge = `<span class="badge badge-info">${single_image_post_text}</span>`;
          }
          if (data.content_type_is_story_post) {
            badge = `<span class="badge badge-primary">${story_text}</span>`;
          }
          if (data.content_type_is_video) {
            badge = `<span class="badge badge-warning">${video_text}</span>`;
          }
          if (data.content_type_is_reel) {
            badge = `<span class="badge badge-success">${reel_text}</span>`;
          }
          if (data.is_multipost) {
            badgeMultiPost = `<span class="badge badge-secondary me-1">${multipost_text} | ${profile_groups_text}: ${info.event._def.extendedProps.multipost_copy_count}</span>`;
          }

          const imageTag = imageSrc
            ? `<img class="mh-200px mw-200px img-thumbnail" src="${imageSrc}" />`
            : '';

          const timeObj = getDateTimeFormated(
              data?.planned_publication_start ||
              data?.planned_publication_datetime ||
              data?.latest_upload_to_platform_timestamp
          )

          const existingTooltips =
            document.getElementsByClassName('singleUseTooltip');
          Array.from(existingTooltips).forEach((tooltip) => tooltip.remove());

          const renderTooltip = `<div class="tooltip singleUseTooltip" id="eventToolTip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="py-1 px-1 d-flex justify-content-between">
               <div class="">
                ${badgeMultiPost}${badge} 
              </div>
               <div class="badge badge-secondary me-1">${timeObj}</div>
              </div>
             
              <div class="d-flex justify-content-center">
                   ${imageTag}  
              </div>
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${data.preview_html}
              </div>
            </div></div>'`;

          if (tooltipInstance) {
            tooltipInstance.dispose();
            tooltipInstance = null;
          }

          tooltipInstance = new Tooltip(info.el, {
            title: 'title',
            html: true,
            placement: 'top',
            trigger: 'hover',
            container: 'body',

            template: renderTooltip
          });

          tooltipInstance.show();
        }}
        eventClick={(info) => {
          let data = info.event._def.extendedProps;

          const date =
            data?.planned_publication_datetime ||
            data?.planned_publication_start ||
            data?.upload_to_platform_timestamp ||
            data?.created;
          if (!isPastDate(date)) {
            info.jsEvent.preventDefault();
            info.jsEvent.stopPropagation();

            const timeValue = moment(date).format('HH:mm');

            dispatch(
              addPublicationDate({
                platform: ALL,
                date: date
              })
            );
            dispatch(
              addPublicationTime({
                platform: ALL,
                time: timeValue
              })
            );

            toast.success(t('lomavisCreator.Scheduling.Date_time_copied'), {
              duration: 4000,
              position: 'top-right',
              id: 'datetime'
            });
          }
        }}
        dateClick={(info) => {
          if (tooltipInstance) {
            tooltipInstance.dispose();
            tooltipInstance = null;
          }

          if (!isPastDate(info?.date)) {
            dispatch(
              addPublicationDate({
                platform: ALL,
                date: info?.date
              })
            );
            dispatch(
              addPublicationTime({
                platform: ALL,
                time: bestTimeToPostValue
              })
            );
            toast.success(t('lomavisCreator.Scheduling.Date_copied'), {
              duration: 4000,
              position: 'top-right',
              id: 'dateCopied'
            });
          }
        }}
        eventMouseLeave={(info) => {
          if (tooltipInstance) {
            tooltipInstance.dispose();
            tooltipInstance = null;
          }
        }}
        navLinkDayClick={(info) => {
          console.log('Event: ' + info);
        }}
        select={handleDateSelect}
      />
    </div>
  );
};

export default Calendar;
